<app-loader-2 *ngIf="isLoading$ | async"></app-loader-2>

<div *ngIf="!(isLoading$ | async)">
  <app-posts [posts]="posts" [ctx]="postsCtx"></app-posts>
</div>
